import { z } from "zod";
import { jobIdSchema } from "./job-schemas";

const versionNoSchema = z.number().int().min(1).max(2_147_483_647);
const isoDateTimeSchema = z.string().datetime({ offset: true });

export const completionAcknowledgementIdempotencyKeySchema = z
  .string()
  .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{7,127}$/u);

export const acknowledgeJobCompletionInputSchema = z.strictObject({
  jobVersionNo: versionNoSchema,
});

export const jobCompletionAcknowledgementSchema = z.strictObject({
  id: jobIdSchema,
  jobId: jobIdSchema,
  jobVersionNo: versionNoSchema,
  acknowledgedAt: isoDateTimeSchema,
});

export const jobCompletionAcknowledgementResponseSchema = z.strictObject({
  status: z.literal("ok"),
  acknowledgement: jobCompletionAcknowledgementSchema,
});

export const acknowledgeJobCompletionResponseSchema = z.discriminatedUnion("status", [
  z.strictObject({
    status: z.literal("acknowledged"),
    acknowledgement: jobCompletionAcknowledgementSchema,
  }),
  z.strictObject({
    status: z.literal("existing"),
    acknowledgement: jobCompletionAcknowledgementSchema,
  }),
]);

export type AcknowledgeJobCompletionInput = z.infer<typeof acknowledgeJobCompletionInputSchema>;
export type JobCompletionAcknowledgement = z.infer<typeof jobCompletionAcknowledgementSchema>;
export type JobCompletionAcknowledgementResponse = z.infer<
  typeof jobCompletionAcknowledgementResponseSchema
>;
export type AcknowledgeJobCompletionResponse = z.infer<
  typeof acknowledgeJobCompletionResponseSchema
>;
